/* MD — add to bag without leaving the page: minimal drop-down confirmation. */
(function () {
  var COPY = {
    added: 'Added to your bag',
    view: 'View bag',
    checkout: 'Checkout',
    error: 'Something went wrong. Please try again.'
  };

  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var el, timer;

  function css() {
    if (document.getElementById('md-toast-css')) return;
    var s = document.createElement('style');
    s.id = 'md-toast-css';
    s.textContent =
      '.md-toast{position:fixed;top:0;left:50%;z-index:9999;transform:translate(-50%,-120%);' +
      'transition:transform .42s cubic-bezier(.22,.61,.36,1),opacity .3s ease;opacity:0;' +
      'width:min(420px,calc(100vw - 24px));background:#fff;color:#231d17;' +
      'border:1px solid #ddd5c9;border-top:0;box-shadow:0 24px 60px rgba(0,0,0,.10);pointer-events:none}' +
      '.md-toast[data-open]{transform:translate(-50%,0);opacity:1;pointer-events:auto}' +
      '.md-toast__in{display:grid;grid-template-columns:auto minmax(0,1fr);gap:14px;align-items:center;padding:16px 18px}' +
      '.md-toast__img{width:52px;height:auto;aspect-ratio:1/1;object-fit:contain;mix-blend-mode:multiply;display:block}' +
      '.md-toast__copy{display:flex;flex-direction:column;gap:4px;min-width:0}' +
      '.md-toast__kicker{font-family:var(--mono,ui-monospace,Menlo,monospace);font-size:9.5px;letter-spacing:.2em;text-transform:uppercase;color:#8a8378}' +
      '.md-toast__name{font-size:15px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.md-toast__meta{font-family:var(--mono,ui-monospace,Menlo,monospace);font-size:10.5px;letter-spacing:.06em;color:#8a8378}' +
      '.md-toast__acts{display:flex;border-top:1px solid #ddd5c9}' +
      '.md-toast__acts a{flex:1;text-align:center;padding:13px 10px;text-decoration:none;color:inherit;' +
      'font-family:var(--mono,ui-monospace,Menlo,monospace);font-size:10px;letter-spacing:.16em;text-transform:uppercase;transition:background .2s}' +
      '.md-toast__acts a:hover{background:#f6f2ec}' +
      '.md-toast__acts a + a{border-left:1px solid #ddd5c9;background:#4f3923;color:#fff}' +
      '.md-toast__acts a + a:hover{background:#3d2b1a}' +
      '@media (max-width:600px){.md-toast{width:calc(100vw - 16px)}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function node() {
    if (el) return el;
    css();
    el = document.createElement('div');
    el.className = 'md-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<div class="md-toast__in">' +
        '<img class="md-toast__img" alt="" hidden>' +
        '<div class="md-toast__copy">' +
          '<span class="md-toast__kicker"></span>' +
          '<span class="md-toast__name"></span>' +
          '<span class="md-toast__meta"></span>' +
        '</div>' +
      '</div>' +
      '<div class="md-toast__acts">' +
        '<a href="' + root + 'cart"></a>' +
        '<a href="' + root + 'checkout"></a>' +
      '</div>';
    document.body.appendChild(el);
    el.addEventListener('mouseenter', function () { clearTimeout(timer); });
    el.addEventListener('mouseleave', function () { hideLater(6000); });
    return el;
  }

  function hideLater(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () { if (el) el.removeAttribute('data-open'); }, ms || 5200);
  }

  function show(item, error) {
    var t = node();
    var img = t.querySelector('.md-toast__img');
    var acts = t.querySelectorAll('.md-toast__acts a');
    t.querySelector('.md-toast__kicker').textContent = error ? '' : COPY.added;
    t.querySelector('.md-toast__name').textContent = error ? COPY.error : (item && item.product_title || '');
    t.querySelector('.md-toast__meta').textContent = error ? '' : [item && item.variant_title, item && item.price != null ? money(item.price) : ''].filter(Boolean).join('  ·  ');
    acts[0].textContent = COPY.view;
    acts[1].textContent = COPY.checkout;
    t.querySelector('.md-toast__acts').style.display = error ? 'none' : '';
    if (!error && item && item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'); img.hidden = false; }
    else { img.hidden = true; }
    requestAnimationFrame(function () { t.setAttribute('data-open', ''); });
    hideLater(error ? 4000 : 5200);
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        var item = data.items ? data.items[0] : data;
        show(item);
        /* PERF NOTE: previously this dispatched cart:refresh/cart:build immediately
           (with no cart data), then made a separate /cart.js GET just to update the
           cart-count badges. Any listener (e.g. a gift-progress meter) that also
           wanted the current cart total had to fire its OWN /cart.js GET right after
           this one — two requests fetching the identical cart state back to back.
           Now: fetch cart.js once here, use it for the count badges, and hand the
           same cart object to listeners via event.detail so they don't need to
           re-fetch it themselves. */
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count],.cart-count,.header__cart-count').forEach(function (n) {
            n.textContent = c.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: c }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: c }));
        }).catch(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        });
      })
      .catch(function () { show(null, true); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }, true);
})();
